import { Card, FooterMenu, HeaderMenu } from "components"
import moment from "moment"
import { useMemo, useState } from "react"
import toast from "react-hot-toast"
import { exportPdf } from "utils"
import { ExportExcelItemBuildReport } from "./components/ExportExcelItemBuildReport"
import { ExportPdfItemBuildReport } from "./components/ExportPdfItemBuildReport"
import { Filter } from "./components/Filter"
import { ReportTable } from "./components/ReportTable"
import { useItemBuildReport } from "./hooks/useItemBuildReport"
import type { ItemBuildReportFilter } from "./types/itemBuildReport"
import { buildPeriodLabel } from "./utils/itemBuildExportData"

const defaultFilter = (): ItemBuildReportFilter => ({
  start_date: moment().startOf("month").format("YYYY-MM-DD"),
  end_date: moment().endOf("month").format("YYYY-MM-DD"),
  category_id: "0",
  location_id: "0",
  approve_status: "0",
  keyword: "",
})

export default function ItemBuildReportPage() {
  const [filter, setFilter] = useState<ItemBuildReportFilter>(defaultFilter)
  const { data, isLoading, error } = useItemBuildReport(filter)

  const periodLabel = useMemo(
    () => buildPeriodLabel(filter.start_date, filter.end_date),
    [filter.start_date, filter.end_date]
  )

  const handleExport = () => {
    if (!data.length) {
      toast.error("No data to export")
      return
    }

    ExportExcelItemBuildReport({
      data,
      periodLabel,
      title: "ITEM BUILD REPORT",
      fileName: "item_build_report",
    })
  }

  const handleExportPdf = () => {
    if (!data.length) {
      toast.error("No data to export")
      return
    }

    exportPdf({
      documentComponent: (
        <ExportPdfItemBuildReport data={data} periodLabel={periodLabel} />
      ),
      fileName: "item_build_report",
    })
  }

  return (
    <section className="container my-5">
      <HeaderMenu title="ITEM BUILD" className="sticky top-[32px] z-[1]" />
      <section className="my-2 space-y-2">
        <section className="sticky top-[120px] z-[1]">
          <Filter filter={filter} setFilter={setFilter} />
        </section>
        <Card>
          <Card.Body>
            <ReportTable data={data} isLoading={isLoading} error={error} />
          </Card.Body>
        </Card>
      </section>

      <section className="mt-2">
        <FooterMenu
          export={{
            actiontype: "export",
            onClick: handleExport,
          }}
          pdf={{
            actiontype: "pdf",
            onClick: handleExportPdf,
          }}
        />
      </section>
    </section>
  )
}
